import axios from "axios";
import constants from "@/assets/js/constants";

var ctsFileServiceDb = {
    db: null,
    dbName: 'cms_',

    getNewLocalDbId: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    init: async function () {
        this.deleteOldIndexedDBs();
        return new Promise(async (resolve, reject) => {
            var context = this;
            context.dbName = context.dbName + context.getNewLocalDbId();

            window.addEventListener("unload", () => {
                //for ayham: check when this is being called, we need to clear on logout and when user close the browser
                window.indexedDB.deleteDatabase(context.dbName);
            });

            var request = window.indexedDB.open(context.dbName, 1);
            request.onupgradeneeded = function (event) {
                context.db = event.target.result;
                if (!context.db.objectStoreNames.contains("files")) {
                    context.db.createObjectStore("files", { keyPath: "localDbId" });
                }

                if (!context.db.objectStoreNames.contains("metadata")) {
                    const store = context.db.createObjectStore("metadata", { keyPath: "id" });
                    console.log("Metadata store created");
    
                    // Store the creation timestamp
                    const tx = event.target.transaction;
                    const metadataStore = tx.objectStore("metadata");
                    metadataStore.add({ id: "creationDate", createdAt: Date.now() });
                }
                
                resolve();
            };

            messagesUtil.listenToEvents(function (eventDetail) {
                if (eventDetail.key == 'UserLoggedOut') {
                    window.indexedDB.deleteDatabase(context.dbName);
                }
            });
        });
    },

    db_storeObject: async function (localDbId, fileData) {
        var context = this;

        return new Promise(async (resolve, reject) => {
            const transaction = context.db.transaction(["files"], "readwrite");
            const store = transaction.objectStore("files");

            store.put({ localDbId: localDbId, fileData: fileData });
            transaction.oncomplete = () => {
                resolve();
                console.log("File stored successfully!")
            };
        });
    },

    db_getObject: async function (localDbId) {
        var context = this;
        return new Promise(async (resolve, reject) => {
            const transaction = context.db.transaction(["files"], "readonly");
            const store = transaction.objectStore("files");

            const request = store.get(localDbId);
            request.onsuccess = function (event) {
                const storedObj = event.target.result;
                if (storedObj) {
                    resolve(storedObj.fileData)
                } else {
                    console.log("File not found");
                }
            };
        });
    },

    deleteOldIndexedDBs: async function () {
        try{
        const dbs = await indexedDB.databases();
        const oneDayAgo = Date.now() - 24 * 60 * 60 * 1000;
        for (const db of dbs) {
            if (db.name) {
                // Open the database and check the creation date
                const request = indexedDB.open(db.name);
                request.onsuccess = function (event) {
                    const dbInstance = event.target.result;
                    const tx = dbInstance.transaction("metadata", "readonly");
                    const store = tx.objectStore("metadata");
                    const request = store.get("creationDate");     
                           
                    request.onsuccess = function () {
                          // If you decide to delete it
                        const creationDate = request.result;      
                        if (creationDate && creationDate.createdAt < oneDayAgo) {
                            indexedDB.deleteDatabase(db.name);
                            console.log(`Deleted IndexedDB: ${db.name}`);
                        } else {
                            console.log(`Skipping IndexedDB: ${db.name}, not older than a day.`);
                        }
                    };

                    dbInstance.close();
                };
            }
        }
    }
       catch(error) {console.log(error)};
    }



}

//var fileMaxArraySize = 10;
var messagesUtil = window.MessagesUtil;
var CTS_F = [];
await ctsFileServiceDb.init();

messagesUtil.listenToEvents(function (eventDetail) {
    if (eventDetail.key == 'correspondencesLoaded') {
        if (!constants.disableFileService)
            prepareFiles(eventDetail.documentsAttachmentsIds);
    }
});

async function prepareFiles(documentsAttachmentsIds) {
    if (documentsAttachmentsIds != null && documentsAttachmentsIds != undefined) {
        for (var i = 0; i < documentsAttachmentsIds.length; i++) {
            var x = documentsAttachmentsIds[i];

            var fileObject = {
                attachmentId: x.attachmentId,
                documentId: x.documentId,
                versionId: x.versionId ? x.versionId : null,
                templateId: x.templateId,
                fileName: x.fileName,
                openedFromLinkedDocumentId: x.openedFromLinkedDocumentId,
                status: FileStatusesEnum.NotStarted.key,
                localDbId: ctsFileServiceDb.getNewLocalDbId()
            }

            fileObject = prepareFileObject(fileObject);

            const fileObjectDoesNotExist = !CTS_F.some(x =>
                x.attachmentId == fileObject.attachmentId &&
                x.documentId == fileObject.documentId &&
                x.versionId == fileObject.versionId &&
                x.templateId == fileObject.templateId &&
                x.fileName == fileObject.fileName
            );

            if (fileObjectDoesNotExist && (fileObject.attachmentId || fileObject.templateId)) {
                CTS_F.push(fileObject);
            }
        }
        // //add not exists only 
        // CTS_F = documentsAttachmentsIds.foreac(x => {
        //     var fileObject = {
        //         attachmentId: x.attachmentId,
        //         documentId: x.documentId,
        //         versionId: x.versionId ? x.versionId : null,
        //         templateId: x.templateId,
        //         fileName: x.fileName,
        //         openedFromLinkedDocumentId: x.openedFromLinkedDocumentId,
        //         status: FileStatusesEnum.NotStarted.key,
        //         fileData: null
        //     }

        //     fileObject = prepareFileObject(fileObject);

        //     return fileObject;
        // });

        //remove duplicate records
        CTS_F = CTS_F.filter((item, index, self) =>
            index === self.findIndex(x =>
                x.attachmentId == item.attachmentId &&
                x.documentId == item.documentId &&
                x.versionId == item.versionId &&
                x.templateId == item.templateId &&
                x.fileName == item.fileName
            ));

        runProcessFilesTimer();
    }
}

function prepareFileObject(fileObject) {
    fileObject.documentId = fileObject.documentId ? fileObject.documentId : null;
    fileObject.attachmentId = fileObject.attachmentId ? fileObject.attachmentId : null;
    fileObject.versionId = fileObject.versionId ? fileObject.versionId : null;
    fileObject.templateId = fileObject.templateId ? fileObject.templateId : null;
    fileObject.fileName = fileObject.fileName ? fileObject.fileName : null;
    fileObject.localDbId = fileObject.localDbId ? fileObject.localDbId : ctsFileServiceDb.getNewLocalDbId();
    return fileObject;
}

async function getFile(fileObject) {
    console.log('=== CTSFileService.getFile CALLED ===');
    console.log('Raw fileObject received:', JSON.stringify(fileObject));
    console.log('attachmentId:', fileObject.attachmentId);
    debugger;
    fileObject = prepareFileObject(fileObject);
    console.log('After prepareFileObject:', JSON.stringify(fileObject));

    return new Promise(async (resolve, reject) => {
        var fileData = null;
        var cachedFileObject = CTS_F.find(x =>
            x.attachmentId == 0 &&  //TODO: remove this destroy the cache for all files moath
            x.versionId == fileObject.versionId &&
            x.templateId == fileObject.templateId &&
            x.fileName == fileObject.fileName) ?? {};

        if (Object.keys(cachedFileObject).length == 0) {
            CTS_F.push({
                attachmentId: fileObject.attachmentId,
                versionId: fileObject.versionId,
                documentId: fileObject.documentId,
                templateId: fileObject.templateId,
                fileName: fileObject.fileName,
                openedFromLinkedDocumentId: fileObject.openedFromLinkedDocumentId,
                status: FileStatusesEnum.NotStarted.key,
                localDbId: ctsFileServiceDb.getNewLocalDbId()
            });

            fileData = await processFile(fileObject)
        } else {
            if (cachedFileObject.status == FileStatusesEnum.Ready.key) {
                if (!cachedFileObject.attachmentId && cachedFileObject.templateId) {
                    fileData = await ctsFileServiceDb.db_getObject(cachedFileObject.localDbId);
                } else {
                    fileData = await ctsFileServiceDb.db_getObject(cachedFileObject.localDbId);

                    if (!fileObject.versionId) {
                        var attachment = await getAttachmentLatestVerion(fileObject.attachmentId);
                        if (attachment != null && (fileData.Version != attachment.version || fileData.MinorVersion != attachment.minorVersion)) {
                            fileData = await processFile(fileObject)
                        }
                    }
                }

            } else if (cachedFileObject.status == FileStatusesEnum.NotStarted.key) {
                runProcessFilesTimer_stopStart('stop');
                fileData = await processFile(fileObject);
                runProcessFilesTimer_stopStart('start');

            } else if (cachedFileObject.status == FileStatusesEnum.InProgress.key) {
                fileData = await waitInProgressFile(fileObject);
            }
        }

        resolve(fileData);
    });
}

const waitInProgressFile = async (fileObject) => {
    return new Promise((resolve, reject) => {
        const check = () => {
            const file = CTS_F.find(x =>
                x.attachmentId == fileObject.attachmentId &&
                x.templateId == fileObject.templateId);

            if (file && file.status === FileStatusesEnum.Ready.key) {
                resolve(file.fileData);
            } else {
                setTimeout(check, 25);
            }
        };
        check();
    });
};

function abortHttpCalls() {

    var files = CTS_F.filter(x => x.status == FileStatusesEnum.InProgress.key);

    files.forEach(item => {

        const controller = item.httpRequestController;

        if (controller) {
            controller.abort();
        }

        var index = CTS_F.findIndex(x => x.attachmentId === item.attachmentId);
        CTS_F[index] = {
            ...CTS_F[index],
            status: FileStatusesEnum.NotStarted.key
        };

    });
};

var runProcessFilesTimer_Locked = false;
var runProcessFilesTimer_allowHttpCalls = true;
function runProcessFilesTimer_stopStart(isStop) {
    if (isStop == 'stop') {
        abortHttpCalls();
        runProcessFilesTimer_allowHttpCalls = false;
    } else {
        runProcessFilesTimer_allowHttpCalls = true;
        runProcessFilesTimer_Locked = false;
        runProcessFilesTimer();
    }
}

async function runProcessFilesTimer_Execute() {
    if (runProcessFilesTimer_Locked) {
        return;
    }

    runProcessFilesTimer_Locked = true;

    var notStartedFiles = CTS_F.filter(x => x.status === FileStatusesEnum.NotStarted.key);
    if (notStartedFiles.length > 0) {
        console.log('=== BACKGROUND TIMER PROCESSING FILES ===');
        console.log('Files to process:', notStartedFiles.map(f => ({ attachmentId: f.attachmentId, documentId: f.documentId, versionId: f.versionId })));
    }

    for (var item of notStartedFiles) {
        if (runProcessFilesTimer_allowHttpCalls) {
            console.log('Background processing file with attachmentId:', item.attachmentId);
            await processFile({ attachmentId: item.attachmentId, documentId: item.documentId, versionId: item.versionId });
        }
    }

    runProcessFilesTimer_Locked = false;
}

async function runProcessFilesTimer() {
    if (!CTS_F.some(x => x.status == FileStatusesEnum.NotStarted.key)) {
        return;
    }

    await runProcessFilesTimer_Execute();

    setTimeout(() => {
        runProcessFilesTimer();
    }, (50));
}

async function processFile(fileObject) {
    return new Promise(async (resolve, reject) => {
        const controller = new AbortController();

        var index = CTS_F.findIndex(x =>
            x.attachmentId === fileObject.attachmentId &&
            x.versionId == fileObject.versionId &&
            x.templateId == fileObject.templateId
        );

        CTS_F[index] = {
            ...CTS_F[index],
            status: FileStatusesEnum.InProgress.key,
            httpRequestController: controller
        };

        if (fileObject.fileName) {
            await axios.get(constants.baseApiUrl + "ViewerActions/GetTempFile?fileName=" + fileObject.fileName, { signal: controller.signal })
                .then(response => {
                    if (response.data != null && response.data != undefined) {

                        CTS_F[index] = {
                            ...CTS_F[index],
                            status: FileStatusesEnum.Ready.key
                        };

                        ctsFileServiceDb.db_storeObject(CTS_F[index].localDbId, response.data);

                        resolve(response.data);
                    }
                })
                .catch(error => console.log(error))
        } else {
            var apiUrl = constants.baseApiUrl + "ViewerActions/GetFile?"
                + "documentId=" + (fileObject.documentId ?? 0)
                + "&attachmentId=" + (fileObject.attachmentId ?? 0)
                + "&templateId=" + (fileObject.templateId ?? 0)
                + "&versionId=" + (fileObject.versionId ?? 0)               
                + "&openedFromLinkedDocumentId=" + (fileObject.openedFromLinkedDocumentId ?? 0); 

            console.log('=== CALLING BACKEND API ===');
            console.log('Full API URL:', apiUrl);
            console.log('attachmentId being sent as Id parameter:', fileObject.attachmentId);
            console.log('========================');

            await axios.get(apiUrl, { signal: controller.signal })
                .then(response => {
                    if (response != null && response.data != null && response.data != undefined && response.data != "") {
                        CTS_F[index] = {
                            ...CTS_F[index],
                            version: response.data.Version,
                            minorVersion: response.data.MinorVersion,
                            status: FileStatusesEnum.Ready.key
                        };
                    }
                    ctsFileServiceDb.db_storeObject(CTS_F[index].localDbId, response.data);

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        }
    });
}

export async function getAttachmentLatestVerion(attachmentId) {
    return new Promise(async (resolve, reject) => {
        var data = null;
        await axios.get(constants.baseApiUrl + "Attachment/GetAttachmentLatestVerion?attachmentId=" + attachmentId)
            .then(response => {
                if (response.data != null && response.data != undefined) {
                    data = response.data;
                } else {
                    data = 0;
                }
            })
            .catch(error => console.log(error))
        resolve(data);
    });
}
export default { getFile }

var FileStatusesEnum = {
    NotStarted: {
        key: "notStarted",
        value: 1
    },
    InProgress: {
        key: "inProgress",
        value: 2
    },
    Ready: {
        key: "ready",
        value: 3
    }
};